import { PlusCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, ConfigProvider, Pagination, PaginationProps } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../../Layout';
import './style.scss'
import AccountRoleItem from './Components/AccountRoleItem';
import AccountRoleList from './Components/AccountRoleList';
import EmptyComponent from '../../../components/EmptyComponent/EmptyComponent';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import viVN from 'antd/locale/vi_VN';
import useToast from '../../../hook/useToast';
import useDebounce from '../../../hook/useDebounce';
import * as groupPermissionApi from '../../../api/groupPermission/groupPermissionApi';
import { dataPagination, getUserPermissions } from '../../../until';
import useLoading from '../../../hook/useLoading';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatNumber } from '../../../services/mixin';

const AccountRole: React.FC = () => {
  useEffect(() => {
    document.title = 'THACO AUTO CRM';

    gListGroupPermission()

    return () => {

      setIdRole(undefined)

      setPagination({ current: 1, pageSize: 10, total: 0 })

      setListRole([])
    }

  }, []);

  const pushToast = useToast();
  const pushLoading = useLoading();
  const navigate = useNavigate()
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isDelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [isOpenDeleteAccountRole, setIsOpenDeleteAccountRole] = useState<boolean>(false)
  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: paginationTmp, pageSize: 10, total: 0 });

  const [idRole, setIdRole] = useState<number>()
  const [listRole, setListRole] = useState<groupPermissionApi.IGroupPermission[]>([])

  const gListGroupPermission = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await groupPermissionApi.getListGroupPermission(pageSize, pageCurent)
    if (result?.status) {

      setListRole(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListGroupPermission(pageNumber, pageSize)
  }

  const onEdit = (id: number) => {
    navigate('/system-configuration/account-role/edit', { state: { id: id } })
  }

  const openModalDelete = (id: number) => {
    setIdRole(id)
    setIsOpenDeleteAccountRole(true)
  }

  const closeModalDelete = () => {
    setIdRole(undefined)
    setIsOpenDeleteAccountRole(false)
  }

  const onConfirmDelete = async () => {
    const result = await groupPermissionApi.deleteGroupPermission(Number(idRole))
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDelete()
      gListGroupPermission()
    } else {
      pushToast(result?.message, "warning")
    }
  }

  return (
    <Layout>
      <ModalDeleteManager
        isOpen={isOpenDeleteAccountRole}
        title="Bạn có chắc chắn xóa nhóm này"
        titleDelete="Xóa nhóm"
        content="Nhóm và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
      />
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Cấu hình</a>,
          },
          {
            title: 'Phân quyền',
          },
        ]}
      />
      <div className='title-page'>
        Phân quyền theo nhóm
      </div>
      <div className='d-flex align-center justify-between  pb-18-px '>
        <p className='text-base font-medium text-344054 white-space-nowrap'>Danh sách nhóm</p>
        <button
          className={`px-4 h-8 white-space-nowrap d-flex justify-center align-center border-none text-white bg-096DD9 rounded-2 text-sm font-regular gap-10-px ${!add && "disabled"}`}
          onClick={() => navigate('/system-configuration/account-role/add')}
        >
          <PlusCircleOutlined className='text-sm text-white' />
          Thêm mới nhóm
        </button>
      </div>

      {
        listRole?.length > 0
          ?
          <AccountRoleList>
            {
              listRole.map((item) => (
                <AccountRoleItem
                  key={item.id}
                  item={item}
                  edit={edit}
                  isDelete={isDelete}
                  onEdit={onEdit}
                  onDelete={openModalDelete}
                  // onShowInfo={() => navigate('/system-configuration/account-role/access', { state: { id: item.id } })}
                />
              ))
            }
          </AccountRoleList>
          :
          <EmptyComponent />
      }
      <div className="custom-page-css mt-auto">
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={paginationTmp}
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>
    </Layout >
  );
}

export default AccountRole;
